import React, { Component } from 'react'
import { deleteUserReviewAdmin, backupUserReviewAdmin } from '../../../store/actions/restaurantActions'
import { connect } from 'react-redux'
import MessageReview from '../../users/messagesReview'
import ReviewSummary from '../../users/ReviewSummary'

class AdminReviewsList extends Component {

  state={
    review: '',
    reviewPoints: 1   
  }

  componentDidMount(){
    this._isMounted = true;
  }

  componentWillUnmount(){
    this._isMounted = false;
  }

  deleteReviewInterruptor =(review)=>{
    this.setState({review:review});
    document.getElementById("deleteReviewModal2").style.display = "block";
  }

  messageReviewInterruptor =(review)=>{
    this.setState({review:review});
    document.getElementById("messageModalReview2").style.display = "block";
  }

  closeFunctionDeleteReview =(e)=>{document.getElementById("deleteReviewModal2").style.display = "none";}
  closeFunctionMessageReview =(e)=>{document.getElementById("messageModalReview2").style.display = "none";}
  closeReviewEditor = (review) => {
    document.getElementById(review.id+"reviewEditor").style.display = "none";
  }

  handleReviewEditor = (review) => {
    document.getElementById(review.id+"reviewEditor").style.display = "block";
  }

  handleReviewPoints = (e) => {
    this.setState({reviewPoints:e.target.value})
  }

  handleDeleteReview = (e) => {
    e.preventDefault();
    this.props.backupUserReviewAdmin(this.state.review[1]['review']);
    this.props.deleteUserReviewAdmin(this.state.review[1]['review'], this.state.review[0]);
    document.getElementById("deleteReviewModal2").style.display = "none";
  }

  render(){
    const { reviews, restaurants, users } = this.props;
    var sortReviews = [];

    for(var cont in reviews){
        if(reviews[cont] !== null && reviews[cont]['timestamp'] !== null){
          sortReviews.push([reviews[cont],reviews[cont]['timestamp'].seconds,cont]);
        }
      }
      sortReviews.sort(function(a, b) {
         return a[1] - b[1];
        });
      var sortedReviews = [];
      for(var sorted in sortReviews){
        sortedReviews.push([sortReviews[sorted][2], sortReviews[sorted][0]])
      }      

    return(
    <div className="review-list">
            
            <div id="deleteReviewModal2" className="modal2">
              <div className="modal-content2">
                <span className="close2" onClick={this.closeFunctionDeleteReview}>&times;</span>
                <p>Are you sure you want to delete?</p>
                <p>{this.state.review[1] && this.state.review[1]['review']['name']}</p>
                <div className="input-field" style={{"display": "flex", "justifyContent": "center"}}>
                  <button className="btn pink lighten-1" onClick={this.handleDeleteReview}>Submit</button>
                </div>
              </div>
            </div>     

            <div id="messageModalReview2" className="modal2">
              <div className="modal-content2">
                <span className="close2" onClick={this.closeFunctionMessageReview}>&times;</span>
                <p>Enter message for</p>
                <p>{this.state.review[1] && users && users.find(x=>x.id===this.state.review[1].userId).firstName
                  + ' ' + users.find(x=>x.id===this.state.review[1].userId).lastName}</p>
                <div className="input-field" style={{"display": "flex", "justifyContent": "center"}}>
                  <MessageReview project={this.state.review}/>
                </div>
              </div>
            </div>

      { restaurants && reviews && sortedReviews && sortedReviews.map(review => {
        return(
        <div  key={review[1]['timestamp']['seconds']} style={{"padding":"10px"}}>
          <span>{review[1] && users && users.find(x=>x.id===review[1].userId) && users.find(x=>x.id===review[1].userId).firstName
                  + ' ' + users.find(x=>x.id===review[1].userId).lastName}</span>  
          <ReviewSummary project={ review[1]['review'] } original={restaurants.find(x=>x.restaurantId===review[1]['review']['restaurantId'])} />
          <div className = 'adminButtons' style={{"width":"100%", "display": "flex", "justifyContent": "space-around"}}>
            <button review={review} className="btn pink lighten-1" onClick={()=>{this.deleteReviewInterruptor(review)}}>Delete</button>
            {/* <button className="btn pink lighten-1" onClick={()=>{this.messageReviewInterruptor(review)}}>Message</button> */} 
          </div>
        </div>  
          )
        }) 
      }
        
    </div>
    )
    
  
}
}

const mapStateToProps = (state) => {
  return {
    ...state,
    reviews: state.firestore.data.restaurantReviews2,
    restaurants: state.firestore.ordered.restaurants,
    users: state.firestore.ordered.users
  }
}


const mapDispatchToProps = dispatch => {
  return {
    deleteUserReviewAdmin: (project, reviewId) => dispatch(deleteUserReviewAdmin(project, reviewId)),
    backupUserReviewAdmin: (project) => dispatch(backupUserReviewAdmin(project))
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(AdminReviewsList) 

